export var NEAR_ACTIONS;
(function(NEAR_ACTIONS) {
    NEAR_ACTIONS["CreateAccount"] = "CreateAccount";
    NEAR_ACTIONS["DeployContract"] = "DeployContract";
    NEAR_ACTIONS["FunctionCall"] = "FunctionCall";
    NEAR_ACTIONS["Transfer"] = "Transfer";
    NEAR_ACTIONS["Stake"] = "Stake";
    NEAR_ACTIONS["AddKey"] = "AddKey";
    NEAR_ACTIONS["DeleteKey"] = "DeleteKey";
    NEAR_ACTIONS["DeleteAccount"] = "DeleteAccount";
})(NEAR_ACTIONS || (NEAR_ACTIONS = {}));

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnVtcy9uZWFyLWFjdGlvbnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gTkVBUl9BQ1RJT05TIHtcbiAgQ3JlYXRlQWNjb3VudCA9ICdDcmVhdGVBY2NvdW50JyxcbiAgRGVwbG95Q29udHJhY3QgPSAnRGVwbG95Q29udHJhY3QnLFxuICBGdW5jdGlvbkNhbGwgPSAnRnVuY3Rpb25DYWxsJyxcbiAgVHJhbnNmZXIgPSAnVHJhbnNmZXInLFxuICBTdGFrZSA9ICdTdGFrZScsXG4gIEFkZEtleSA9ICdBZGRLZXknLFxuICBEZWxldGVLZXkgPSAnRGVsZXRlS2V5JyxcbiAgRGVsZXRlQWNjb3VudCA9ICdEZWxldGVBY2NvdW50Jyxcbn1cbiJdLCJuYW1lcyI6WyJORUFSX0FDVElPTlMiXSwicmFuZ2VNYXBwaW5ncyI6Ijs7Ozs7Ozs7OzsiLCJtYXBwaW5ncyI6IjtVQUFZQTs7Ozs7Ozs7O0dBQUFBLGlCQUFBQSJ9